export const FORECAST_ROUND_THRESHOLD = 0.2;

export const roundQuantityWithThreshold = (value, threshold = FORECAST_ROUND_THRESHOLD) => {
  if (!Number.isFinite(value) || value <= 0) {
    return 0;
  }

  const base = Math.floor(value);
  const fraction = value - base;
  return fraction + Number.EPSILON >= threshold ? base + 1 : base;
};

export const roundHoursWithThreshold = (hoursValue, threshold = FORECAST_ROUND_THRESHOLD, minHours = 0) => {
  if (!Number.isFinite(hoursValue) || hoursValue <= 0) {
    return Math.max(minHours, 0);
  }

  const rounded = roundQuantityWithThreshold(hoursValue, threshold);
  return Math.max(minHours, rounded);
};

